<template>
  <ModalDialog
    header-text="Contact Us"
    contentClass="contact-us-modal-content"
    @closeModal="closeModal"
    open
  >
    <template v-slot:content>
      <div class="contact-right">
        Do you have questions regarding your OU account or need help navigating
        this site?
        <br /><br />
        <strong>Office Hours:</strong><br />
        Monday - Thursday 9:00 a.m. to 5:00 p.m. ET<br />
        Friday 9:00 a.m. to 1:00 p.m. ET <br /><br />

        <div v-if="main.companySummary">
          <strong>Account Executive/RC:</strong> <br />
          <div>Rabbi {{ main.companySummary.RcName }}</div>
          <div>{{ main.companySummary.RcPhone }}</div>
          <a
            v-if="main.companySummary.RcEmail"
            :href="'mailto:' + main.companySummary.RcEmail"
            >{{ main.companySummary.RcEmail }}</a
          >
          <br />
        </div>
        <div v-if="main.companySummary" :hidden="!main.companySummary.AdministrativeAssistantName">
          <strong>RC Administrative Assistant:</strong><br />
          <div>{{ main.companySummary.AdministrativeAssistantName }}</div>
          <div>{{ main.companySummary.AdministrativeAssistantPhone }}</div>
          <a
            v-if="main.companySummary.AdministrativeAssistantEmail"
            :href="'mailto:' + main.companySummary.AdministrativeAssistantEmail"
            >{{ main.companySummary.AdministrativeAssistantEmail }}</a
          >
          <br />
        </div>
        <div
          v-if="main.companySummary"
          :hidden="
            !main.companySummary.GroupLeaderName ||
            main.companySummary.GroupLeaderEmail === main.companySummary.RcEmail
          "
        >
          <strong>Additional Contact:</strong> <br />
          <div>Rabbi {{ main.companySummary.GroupLeaderName }}</div>
          <div>{{ main.companySummary.GroupLeaderPhone }}</div>
          <a
            v-if="main.companySummary.GroupLeaderEmail"
            :href="'mailto:' + main.companySummary.GroupLeaderEmail"
            >{{ main.companySummary.GroupLeaderEmail }}</a
          >
          <br />
        </div>
        <strong>OU Help Desk:</strong> <br />
        212-613-8322<br />
        <a href="mailto:directhelp@ou.org">directhelp@ou.org</a>
      </div>
    </template>
  </ModalDialog>
</template>

<script setup lang="ts">
import { useMainStore } from "@/stores/useMainStore";
import ModalDialog from "@/shared/ui/modal/ModalDialog.vue";

const main = useMainStore();

const emit = defineEmits<{
  (e: "closeModal"): void;
}>();

const closeModal = function () {
  emit("closeModal");
};
</script>

<style lang="scss">
.contact-us-modal-content {
  width: 360px;

  .contact-right {
    background: #f7f7f7;
    border: 1px solid #efefef;
    border-radius: 2px;
    padding: 20px;
  }
}
</style>
